package com.tovtalk.database

import app.cash.sqldelight.Transacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.tovtalk.database.androidui.newInstance
import com.tovtalk.database.androidui.schema
import kotlin.Unit

public interface TovTalkDatabase : Transacter {
  public val analyticsEventsQueueQueries: AnalyticsEventsQueueQueries

  public val postQueries: PostQueries

  public val userQueries: UserQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.Value<Unit>>
      get() = TovTalkDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): TovTalkDatabase =
        TovTalkDatabase::class.newInstance(driver)
  }
}
